export const IMPERSONATION_SESSION_ID = 'impersonation-session-id';
export const IMPERSONATION_REFRESH_TOKEN = 'impersonation-refresh-token';
export const IMPERSONATION_ORIGINAL_ACCESS_TOKEN = 'impersonation-original-access-token';
export const IMPERSONATION_ORIGINAL_REFRESH_TOKEN = 'impersonation-original-refresh-token';
export const IMPERSONATION_METADATA = 'impersonation-metadata';

export interface ImpersonationMetadata {
  impersonationSessionId: string;
  reason: string;
  expiresAt: string;
  actor: { userId: string; email: string; name: string };
  target: { userId: string; email: string; name: string; role?: string[] };
}
